import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const cfg = (typeof window !== "undefined" && window.__CLARIDENT__) || {};
const GA4 = (cfg.GA4_MEASUREMENT_ID || "").trim();
const CLARITY = (cfg.CLARITY_PROJECT_ID || "").trim();

let initialized = false;

// Loads GA4 and/or Microsoft Clarity ONLY when a valid public ID is configured
// in /config.js. No IDs => nothing loads, no console errors.
export default function Analytics() {
  const location = useLocation();
  const firstRun = useRef(true);

  useEffect(() => {
    if (initialized) return;
    initialized = true;

    if (/^G-[A-Z0-9]{6,}$/i.test(GA4)) {
      const s = document.createElement("script");
      s.async = true;
      s.src = `https://www.googletagmanager.com/gtag/js?id=${GA4}`;
      document.head.appendChild(s);
      window.dataLayer = window.dataLayer || [];
      window.gtag = function () { window.dataLayer.push(arguments); };
      window.gtag("js", new Date());
      window.gtag("config", GA4, { send_page_view: true });
    }

    if (/^[a-z0-9]{6,}$/i.test(CLARITY)) {
      (function (c, l, a, r, i, t, y) {
        c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
        t = l.createElement(r); t.async = 1; t.src = "https://www.clarity.ms/tag/" + i;
        y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
      })(window, document, "clarity", "script", CLARITY);
    }
  }, []);

  // SPA route-change page views (initial view handled by gtag config).
  useEffect(() => {
    if (firstRun.current) { firstRun.current = false; return; }
    if (typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_path: location.pathname + location.search,
        page_location: window.location.href,
        page_title: document.title,
      });
    }
  }, [location]);

  return null;
}
